let host;
let newHost;
let userHost;
let musMerchantHost;
if (process.env.NODE_ENV === 'production') {
  if (process.env.CUSTOM_ENV === 'test') {
    host = 'https://t-syt-merchant.lepass.cn/merchant-manager'; // 测试环境
    newHost = 'https://t-syt-merchant.lepass.cn/merchant-pc'; // 测试环境
    userHost = 'http://t-usercenter.lepass.cn/usercenter'; // 测试环境
    musMerchantHost = 'https://t-mus.lepass.cn/mus-merchant'; // 测试环境
  } else if (process.env.CUSTOM_ENV === 'pre') {
    host = 'https://p-syt-merchant.lepass.cn/merchant-manager'; // 预发布环境
    newHost = 'https://p-syt-merchant.lepass.cn/merchant-pc'; // 预发布环境
    userHost = 'http://p-usercenter.lepass.cn/usercenter'; // 预发布环境
    musMerchantHost = 'https://p-mus.lepass.cn/mus-merchant'; // 预发布环境
  } else if (process.env.CUSTOM_ENV === 'prd') {
    host = 'https://syt-merchant.leshuazf.com/merchant-manager'; // 正式环境
    newHost = 'https://syt-merchant.leshuazf.com/merchant-pc'; // 正式环境
    userHost = 'https://usercenter.leshuazf.com/usercenter'; // 正式环境
    musMerchantHost = 'https://mus.leshuazf.com/mus-merchant'; // 正式环境
  } else if (process.env.CUSTOM_ENV === 'dev') {
    host = 'https://d-hsy-merchant.lepass.cn/merchant-manager'; // 正式环境
    newHost = 'https://d-hsy-merchant.lepass.cn/merchant-pc'; // 正式环境
    userHost = 'https://d-usercenter.lepass.cn/usercenter'; // 正式环境
    musMerchantHost = 'https://t-mus.lepass.cn/mus-merchant'; // 开发环境
  }
} else {
  host = "/merchant-manager";
  newHost = "/merchant-pc";
  userHost = "/usercenter";
  musMerchantHost = '/mus-merchant';
}

module.exports = {
  host,
  newHost,
  userHost,
  musMerchantHost,
};
